export default {
  PrinterGetFullList: {
    id: 'PrinterGetFullList',
    title: 'Get full printer list',
    type: 'checkbox',
  },
  PrinterName: {
    id: 'PrinterName',
    title: 'Name',
    type: 'select',
    options: [],
    validate: (val) => (val?.length ? null : 'PrinterName is required.'),
  }, // required - select dropdown options from 'https://localhost:{Port}/getprinterlist'
  PrinterVendor: {
    id: 'PrinterVendor',
    title: 'Vendor name',
    type: 'select',
    options: [],
  }, // required - select dropdown options from 'https://localhost:{Port}/getprinterlist'
  PrinterFullCut: {
    id: 'PrinterFullCut',
    title: 'Full Cut',
    type: 'checkbox',
  }, // optional / default true - checkbox
  PrinterOpenCashDrawer: {
    id: 'PrinterOpenCashDrawer',
    title: 'Open Cash Drawer',
    type: 'checkbox',
  }, // optional /default false - checkbox
  PrinterPaperSize: {
    id: 'PrinterPaperSize',
    title: 'Paper Size',
    type: 'text',
  }, // optional integer
  PrinterCharactersPerLine: {
    id: 'PrinterCharactersPerLine',
    title: 'Characters Per Line',
    type: 'text',
  }, // optional - integer
  PrinterTerminalPort: {
    id: 'PrinterTerminalPort',
    title: 'Terminal Port',
    type: 'text',
    validate: (val) => {
      if (val?.length) {
        return val.match(/[^\d]/g)?.length ? 'Invalid Terminal Port' : null;
      }
      return null;
    },
  },
};
